import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import EditInput from "../../../../etc/admin/input"

import * as func from "../../../../../utils/functions";

import * as Actions from "../../../../../store/modules/journals";
import * as FActions from "../../../../../store/modules/footer";

import Titles from "../0_Titles";
import Ids from "../1_Ids";
import {STATUS_NAME} from "../../../../../wpconfig";
import {faLink} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class DefaultForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			status : this.props.record.journal_status
		}
		// this.state = {
		// 	insertRecord: null
		// }
	}

	onChange = (event) => {
		let record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.dataActions.setJournal({"record": record});
		this.forceUpdate()
	}

	useConfirm = (message = null, onConfirm, onCancel) => {
		if (!onConfirm || typeof onConfirm !== "function") {
			return;
		}
		if (onCancel && typeof onCancel !== "function") {
			return;
		}

		if (window.confirm(message)) {
			onConfirm();
		} else {
			onCancel();
		}
	}

	deleteConfirm = () => {
		func.updateData("admin/journal/" + func.getParams("record_id") + "/delete", this.props.record).then((response) => {
			if (response.code === 'ok') {
				this.showMessage('삭제 되었습니다.');
				let url = func.removeParamUrl('record_id');
				location.href = func.removeParamUrl('tab_id', url);
			} else {
				this.showMessage('삭제 실패 : ' + response.return_message.message)
			}
		})
	}
	cancelConfirm = () => this.showMessage('취소 되었습니다.');

	onDelete = () => {
		func.getParams("record_id") ? (
			this.useConfirm("삭제하시겠습니까?", this.deleteConfirm, this.cancelConfirm)
		) : (
			console.log("레코드 아이디가 없으면 삭제 불가능")
		)
	}

	onUpdate = () => {
		if (func.getParams("record_id")) {
			func.updateData("admin/journal/" + func.getParams("record_id") + "/update", this.props.record).then((response) => {
				if (response.code === 'ok') {
					this.showMessage('저장 되었습니다.');
					this.setState({
						status : this.props.record.journal_status
					})
				} else {
					this.showMessage('저장 실패 : ' + response.return_message.message)
				}
			})
		} else {
			func.updateData("admin/journal/insert", this.props.record).then((response) => {
				if (response.code === 'ok') {
					this.showMessage('저장 되었습니다.');
					location.href = func.changeParamUrl('record_id', response.journal_id);
				} else {
					this.showMessage('저장 실패 : ' + response.return_message.message)
				}
			})
		}
	}

	showMessage(message) {
		this.props.fDataActions.setFooter({
			'isNoticePopup': true,
			'noticeMessage': message
		})
		setTimeout(() => {
			this.props.fDataActions.setFooter({
				'isNoticePopup': false,
				'noticeMessage': ''
			})
		}, 3000);
	}

	getListUrl() {
		let url = func.removeParamUrl('record_id');
		return func.removeParamUrl('tab_id', url);
	}

	render() {
		const record = this.props.record;
		return (
			<>
				<div className="d-flex mt-4 mb-1">
					<h5 className="mr-auto">기본 정보</h5>
					<select className="form-control mr-3"
					        name="journal_status" onChange={this.onChange}
					        style={{width : "100px", height: '32px'}}
					        value={record.journal_status}>
						{Object.keys(STATUS_NAME).map((item, index) => {
							if(this.state.status !== 'trash' && item === 'delete')
								return ''
							return (<option key={index} value={item}>{STATUS_NAME[item]}</option>)
						})}
					</select>
					<button className="btn btn-sm btn-primary order-0" type="button" id="save_journal"
					        onClick={this.onUpdate}>저장</button>
					{this.state.status === 'trash' &&
						<button className="btn btn-sm btn-danger order-1 ml-2" type="button" id="save_journal"
						        onClick={this.onDelete}>삭제</button>
					}
					<a href={this.getListUrl()} className="btn btn-sm btn-secondary order-1 ml-2" type="button" id="show_list">리스트</a>
				</div>
				<form>
					<div className="row mb-2">
						<div className="col-md-12 form-main-title">
							<EditInput
								title="저널명"
								value={record.journal_title}
								name="journal_title"
								onKeyUp={this.onChange}
							/>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-3">
							<EditInput
								title="ISSN"
								value={record.issn}
								name="issn"
								onKeyUp={this.onChange}
							/>
						</div>
						<div className="col-md-3">
							<EditInput
								title="E-ISSN"
								value={record.eissn}
								name="eissn"
								onKeyUp={this.onChange}
							/>
						</div>
						<div className="col-md-2">
							<EditInput
								title="국가"
								value={record.country}
								name="country"
								onKeyUp={this.onChange}
							/>
						</div>
						<div className="col-md-2">
							<EditInput
								title="언어"
								value={record.lang}
								name="lang"
								onKeyUp={this.onChange}
							/>
						</div>
						<div className="col-md-2">
							<EditInput
								title="창간년"
								value={record.birth_year}
								name="birth_year"
								onKeyUp={this.onChange}
							/>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-12">
							<Titles />
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-12">
							<label htmlFor="input"><strong>JCR 약어(wos_id)</strong></label>
							<div className="input-group">
								<input type="text" name="wos_id" className="form-control"
									   defaultValue={record.wos_id || ""} onKeyUp={this.onChange}/>
								<div className="input-group-prepend">
									<div className="input-group-text search-scholar">
										<a href={"https://jcr.clarivate.com/jcr-jp/journal-profile?journal="+record.wos_id+"&year=All%20years"} target="_blank">
											<FontAwesomeIcon icon={faLink}/>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-6">
							<label htmlFor="input"><strong>Scopus ID</strong></label>
							<div className="input-group">
								<input type="text" name="scopus_id" className="form-control"
									   defaultValue={record.scopus_id || ""} onKeyUp={this.onChange}/>
								<div className="input-group-prepend">
									<div className="input-group-text search-scholar">
										<a href={"https://www.scopus.com/sourceid/"+record.scopus_id} target="_blank">
											<FontAwesomeIcon icon={faLink}/>
										</a>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<label htmlFor="input"><strong>KCI ID</strong></label>
							<div className="input-group">
								<input type="text" name="kci_id" className="form-control"
									   defaultValue={record.kci_id || ""} onKeyUp={this.onChange}/>
								<div className="input-group-prepend">
									<div className="input-group-text search-scholar">
										<a href={"https://www.kci.go.kr/kciportal/po/search/poCitaView.kci?sereId="+record.kci_id} target="_blank">
											<FontAwesomeIcon icon={faLink}/>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-12">
							<Ids />
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-12">
							<EditInput
								title="간기"
								value={record.frequency}
								name="frequency"
								onKeyUp={this.onChange}
							/>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-6">
							<EditInput
								title="발행기관"
								value={record.publisher}
								name="publisher"
								onKeyUp={this.onChange}
							/>
						</div>
						<div className="col-md-6">
							<EditInput
								title="발행기관(번역)"
								value={record.publisher_translation}
								name="publisher_translation"
								onKeyUp={this.onChange}
							/>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-12">
							<EditInput
								title="주소"
								value={record.address}
								name="address"
								onKeyUp={this.onChange}
							/>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-5">
							<EditInput
								title="홈페이지"
								value={record.home_url}
								name="home_url"
								onKeyUp={this.onChange}
							/>
						</div>
						<div className="col-md-4">
							<EditInput
								title="DOI"
								value={record.doi}
								name="doi"
								onKeyUp={this.onChange}
							/>
						</div>
						<div className="col-md-3 form-group">
							<label htmlFor=""><strong>Open Access</strong></label>
							<div className="mt-1">
								<div className="form-check form-check-inline">
									<input className="form-check-input" type="radio" name="open_access"
									       id="oa_yes" value="y" checked={record.open_access === 'y'} onChange={this.onChange}/>
									<label className="form-check-label" htmlFor="oa_yes">예</label>
								</div>
								<div className="form-check form-check-inline">
									<input className="form-check-input" type="radio" name="open_access"
									       id="oa_no" value="n" checked={record.open_access !== 'y'} onChange={this.onChange}/>
									<label className="form-check-label" htmlFor="oa_no">아니오</label>
								</div>
							</div>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-12">
							<div className="form-group">
								<label><strong>토픽</strong></label>
								<div>
										<textarea
											title="토픽"
											value={record.topic || ''}
											name="topic"
											className="form-control"
											onChange={this.onChange}
										/>
								</div>
							</div>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-12">
							<div className="form-group">
								<label><strong>요약</strong></label>
								<div>
										<textarea
											title="요약"
											value={record.summary || ''}
											name="summary"
											className="form-control"
											onChange={this.onChange}
										/>
								</div>
							</div>
						</div>
					</div>
				</form>

				{/*<JournalMeta/>*/}
			</>
		)
	}
}

export default connect(
	(state) => ({
		record: state.journals.record ? state.journals.record : {},
		meta: state.journals.meta ? state.journals.meta : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(DefaultForm)

DefaultForm.propTypes = {
	// args : PropTypes.object,
	// facet : PropTypes.object,
};


// DefaultForm.propTypes = {
//   args: PropTypes.object,
//   facet: PropTypes.object,
// };
